import React from 'react';
import { Link } from 'react-router-dom';
import { MessageSquareQuote, ArrowRight } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import './QuoteNeed.css';

export default function QuoteNeed({ to = '/contact', cta }) {
  const { t } = useLanguage();
  const q = t.homeQuote;

  return (
    <section className="section quote-need">
      <div className="container">
        <div className="quote-need-card">
          <div className="quote-need-icon">
            <MessageSquareQuote size={28} />
          </div>
          <div className="quote-need-copy">
            <h2>{q.title}</h2>
            <p className="quote-need-sub">{q.subtitle}</p>
            <p>{q.text}</p>
          </div>
          <Link to={to} className="btn btn-primary quote-need-btn">
            {cta || 'Contactez-nous'}
            <ArrowRight size={18} />
          </Link>
        </div>
      </div>
    </section>
  );
}
